/** @format */

import * as Sentry from '@sentry/react'
import React, {StrictMode, useEffect} from 'react'
import {createRoot, hydrateRoot} from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'

import {AccountContextProvider} from '@src/contexts/AccountContext'
import {LoadingContextProvider} from '@src/contexts/LoadingContext'
import {PosthogContextProvider} from '@src/contexts/PosthogContext'

import {initAmplitude, initSentry} from './bootstrap'
import {markReactReady} from './plans/markReactReady'
import PlansPage from './plans/PlansPage'

// The /plans page gets its own entry point rather than riding on App.js: it is
// the only pre-login page of the SPA, so it must not pull in the dashboard
// (Monaco, the form editor, the router's other lazy routes). PlansPage is
// imported eagerly here — there is nothing else to route to.

initSentry()

function PlansApp() {
  useEffect(() => {
    initAmplitude()
    markReactReady()
  }, [])

  return (
    <PosthogContextProvider>
      <LoadingContextProvider>
        <AccountContextProvider userOptional>
          <BrowserRouter>
            <PlansPage />
          </BrowserRouter>
        </AccountContextProvider>
      </LoadingContextProvider>
    </PosthogContextProvider>
  )
}

const container = document.getElementById('body')

const tree = (
  <StrictMode>
    {window.formspree && window.formspree.SENTRY_DSN_REACT ? (
      <Sentry.ErrorBoundary fallback="An error has occurred" showDialog>
        <PlansApp />
      </Sentry.ErrorBoundary>
    ) : (
      <PlansApp />
    )}
  </StrictMode>
)

// The server ships the page already rendered (scripts/prerender-plans.js), so
// attach to that markup rather than replacing it. An empty root means the
// partial was not built — a checkout without `yarn build` — so render it here.
if (container.firstElementChild) {
  hydrateRoot(container, tree)
} else {
  createRoot(container).render(tree)
}
